import React from "react";
import Wallet from "../../components/Shop/Wallet";

const ProfileWithdraw = () => {
  return <Wallet />;
};

export default ProfileWithdraw;

